<template>
    <div>
        <base-header type="gradient-success" class="pb-5 pb-5 pt-3 pt-md-5">
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-12 col-lg-12">
                    <stats-card title="VUE_APP_API_URL"
                                type="gradient-red"
                                :sub-title="VUE_APP_API_URL"
                                icon="ni ni-compass-04"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-cloud-download"></i> API URL</span>
                            <span class="text-nowrap"></span>
                        </template>
                    </stats-card>
                </div>
                <br>
                <div class="col-xl-12 col-lg-12">
                    <stats-card title="VUE_APP_END_POINT"
                                type="gradient-orange"
                                :sub-title="VUE_APP_END_POINT"
                                icon="ni ni-settings"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-cloud"></i> End Point</span>
                            <span class="text-nowrap"></span>
                        </template>
                    </stats-card>
                </div>
                <br>
                <div class="col-xl-12 col-lg-12">
                    <stats-card title="VUE_APP_PUBLIC_URL"
                                type="gradient-green"
                                :sub-title="VUE_APP_PUBLIC_URL"
                                icon="ni ni-world"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-server"></i> Public URL</span>
                            <span class="text-nowrap"></span>
                        </template>
                    </stats-card>

                </div>
            </div>
        </base-header>
    </div>
</template>
<script>
  export default {
    name: 'tables',
    components: {
    },
    data() {
            return {
                VUE_APP_API_URL: process.env.VUE_APP_API_URL,
                VUE_APP_END_POINT: process.env.VUE_APP_END_POINT,
                VUE_APP_PUBLIC_URL: process.env.VUE_APP_PUBLIC_URL
            }
        }
  };
</script>
<style></style>
